import React from 'react';
import { Box, Typography, Alert, Paper } from '@mui/material';
import MessageQueryView from './MessageQueryView';

const MessageQueryDemo = () => {
  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: '#f5f5f5' }}>
      {/* Header */}
      <Paper sx={{ p: 3, mb: 3, backgroundColor: '#1976d2', color: 'white' }}>
        <Typography variant="h3" gutterBottom>
          📊 Dashboard de Estadísticas de Mensajes
        </Typography>
        <Typography variant="h6">
          Panel interactivo con gráficos y métricas de templates de WhatsApp
        </Typography>
      </Paper>

      {/* Information Alert */}
      <Box sx={{ px: 3, mb: 3 }}>
        <Alert severity="info" sx={{ mb: 2 }}>
          <Typography variant="body1" gutterBottom>
            <strong>Funcionalidades del Dashboard:</strong>
          </Typography>
          <ul style={{ margin: 0, paddingLeft: '20px' }}>
            <li><strong>📊 Gráficos Interactivos:</strong> Visualización de datos con gráficos de barras, líneas y pastel</li>
            <li><strong>📈 Métricas en Tiempo Real:</strong> Total de mensajes, recipients y templates</li>
            <li><strong>🎯 Análisis de Entrega:</strong> Tasas de entrega y lectura por template</li>
            <li><strong>📅 Filtros de Período:</strong> Día, semana, mes o rango personalizado</li>
            <li><strong>📋 Vista Detallada:</strong> Estadísticas completas por cada template</li>
          </ul>
        </Alert>
        
        <Alert severity="warning">
          <Typography variant="body2">
            <strong>Nota:</strong> Esta es una demostración del componente. Las consultas reales requieren autenticación y conexión al backend.
          </Typography>
        </Alert>
      </Box>

      {/* Main Component */}
      <MessageQueryView />
    </Box>
  );
};

export default MessageQueryDemo;
